<script setup>
import AppLayout from '@/Layouts/AppLayout.vue'
import DemandForm from '@/Pages/Contacts/Partials/DemandForm.vue'
import { contacts } from '@/actions/App/Http/Controllers/PageController'
import { DevicePhoneMobileIcon, EnvelopeOpenIcon } from '@heroicons/vue/24/outline'
import { usePage } from '@inertiajs/vue3'

defineProps({
    demand_types: {
        type: Array,
        required: true,
    },

    demand_of_constructions: {
        type: Array,
        required: true,
    },
})
</script>

<template>
    <AppLayout
        meta_title="Kontakt - sádrokartonářské práce, foukaná izolace"
        meta_description="Nabízíme montáž sádrokartonu, foukanou izolaci i betonové stěrky v Olomouci a okolí. Obraťte se na nás pro cenovou nabídku zdarma."
        :meta_canonical="contacts.url()"
    >
        <template #content>
            <section class="section-width mt-16 !max-w-4xl">
                <header
                    id="kontaktni-formular"
                    class="header-width scroll-mt-30"
                >
                    <h2 class="header-h">Kontaktujte nás</h2>
                </header>

                <div class="mt-20 grid gap-y-10">
                    <div
                        class="col-span-full grid grid-cols-1 items-center justify-center gap-y-10 lg:grid-cols-3 lg:gap-2 lg:gap-y-0"
                    >
                        <div class="flex flex-col space-y-2">
                            <div class="text-center text-xl font-semibold">
                                <span class="text-brand-orange">{{ usePage().props.contacts[0].name }}</span>
                            </div>

                            <div class="flex h-full w-full">
                                <div
                                    class="bg-brand-orange relative flex w-full flex-col items-center justify-center rounded-3xl px-6 py-2"
                                >
                                    <div class="block">
                                        <component
                                            :is="EnvelopeOpenIcon"
                                            class="size-12 p-2 text-white"
                                        />
                                    </div>

                                    <div class="relative mt-2 w-full text-center opacity-100">
                                        <span class="font-chivo text-sm text-white">
                                            {{ usePage().props.contacts[0].email }}
                                        </span>
                                    </div>

                                    <a
                                        :href="'mailto:' + usePage().props.contacts[0].email"
                                        rel="noopener noreferrer"
                                        aria-label="Napsat e-mail"
                                        class="absolute inset-0"
                                    />
                                </div>
                            </div>

                            <div class="flex h-full w-full">
                                <div
                                    class="bg-brand-orange relative flex w-full flex-col items-center justify-center rounded-3xl px-6 py-2"
                                >
                                    <div class="block">
                                        <component
                                            :is="DevicePhoneMobileIcon"
                                            class="size-12 p-2 text-white"
                                        />
                                    </div>

                                    <div class="relative mt-2 w-full text-center opacity-100">
                                        <span class="font-chivo text-sm text-white">
                                            {{ usePage().props.contacts[0].phone }}
                                        </span>
                                    </div>

                                    <a
                                        :href="'tel:' + usePage().props.contacts[0].phone"
                                        rel="noopener noreferrer"
                                        aria-label="Zavolat"
                                        class="absolute inset-0"
                                    />
                                </div>
                            </div>
                        </div>

                        <div class="flex flex-col space-y-2">
                            <div class="text-center text-xl font-semibold">
                                <span class="text-brand-orange">{{ usePage().props.contacts[1].name }}</span>
                            </div>

                            <div class="col-span-full flex h-full w-full lg:col-span-2">
                                <div
                                    class="bg-brand-orange relative flex w-full flex-col items-center justify-center rounded-3xl px-6 py-2"
                                >
                                    <div class="block">
                                        <component
                                            :is="EnvelopeOpenIcon"
                                            class="size-12 p-2 text-white"
                                        />
                                    </div>

                                    <div class="relative mt-2 w-full text-center opacity-100">
                                        <span class="font-chivo text-sm text-white">
                                            {{ usePage().props.contacts[1].email }}
                                        </span>
                                    </div>

                                    <a
                                        :href="'mailto:' + usePage().props.contacts[1].email"
                                        rel="noopener noreferrer"
                                        aria-label="Napsat e-mail"
                                        class="absolute inset-0"
                                    />
                                </div>
                            </div>

                            <div class="col-span-full flex h-full w-full lg:col-span-2">
                                <div
                                    class="bg-brand-orange relative flex w-full flex-col items-center justify-center rounded-3xl px-6 py-2"
                                >
                                    <div class="block">
                                        <component
                                            :is="DevicePhoneMobileIcon"
                                            class="size-12 p-2 text-white"
                                        />
                                    </div>

                                    <div class="relative mt-2 w-full text-center opacity-100">
                                        <span class="font-chivo text-sm text-white">
                                            {{ usePage().props.contacts[1].phone }}
                                        </span>
                                    </div>

                                    <a
                                        :href="'tel:' + usePage().props.contacts[1].phone"
                                        rel="noopener noreferrer"
                                        aria-label="Zavolat"
                                        class="absolute inset-0"
                                    />
                                </div>
                            </div>
                        </div>

                        <div class="lex flex-col space-y-2">
                            <div class="text-center text-xl font-semibold">
                                <span class="text-brand-orange">Účetní: {{ usePage().props.accountant.name }}</span>
                            </div>

                            <div class="col-span-full flex h-full w-full lg:col-span-2">
                                <div
                                    class="bg-brand-orange relative flex w-full flex-col items-center justify-center rounded-3xl px-6 py-2"
                                >
                                    <div class="block">
                                        <component
                                            :is="EnvelopeOpenIcon"
                                            class="size-12 p-2 text-white"
                                        />
                                    </div>

                                    <div class="relative mt-2 w-full text-center opacity-100">
                                        <span class="font-chivo text-sm text-white">
                                            {{ usePage().props.accountant.email }}
                                        </span>
                                    </div>

                                    <a
                                        :href="'mailto:' + usePage().props.accountant.email"
                                        rel="noopener noreferrer"
                                        aria-label="Napsat e-mail"
                                        class="absolute inset-0"
                                    />
                                </div>
                            </div>

                            <div class="col-span-full flex h-full w-full lg:col-span-2">
                                <div
                                    class="bg-brand-orange relative flex w-full flex-col items-center justify-center rounded-3xl px-6 py-2"
                                >
                                    <div class="block">
                                        <component
                                            :is="DevicePhoneMobileIcon"
                                            class="size-12 p-2 text-white"
                                        />
                                    </div>

                                    <div class="relative mt-2 w-full text-center opacity-100">
                                        <span class="font-chivo text-sm text-white">
                                            {{ usePage().props.accountant.phone }}
                                        </span>
                                    </div>

                                    <a
                                        :href="'tel:' + usePage().props.accountant.phone"
                                        rel="noopener noreferrer"
                                        aria-label="Zavolat"
                                        class="absolute inset-0"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-span-full">
                        <DemandForm
                            :demand_types="demand_types"
                            :demand_of_constructions="demand_of_constructions"
                        />
                    </div>
                </div>
            </section>
        </template>
    </AppLayout>
</template>
